/* eslint-disable */
export default {
  logged: 'Enregistré',
  unlogged: 'Non traité',
  faxNotSupported:
    'L’option permettant de journaliser un fax n’est pas prise en charge.',
} as const;

// @key: @#@"logged"@#@ @source: @#@"Logged"@#@
// @key: @#@"unlogged"@#@ @source: @#@"Unworked"@#@
// @key: @#@"faxNotSupported"@#@ @source: @#@"To log fax is not supported."@#@
